import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {Banner, Link, PageLayout} from '@primer/react'
import MarketplaceHeader from '@github-ui/marketplace-common/MarketplaceHeader'
import MarketplaceNavigation from '@github-ui/marketplace-common/MarketplaceNavigation'
import type {IndexPayload} from '@github-ui/marketplace-common'
import {SearchAndFilterProviderStack} from '@github-ui/marketplace-common/SearchAndFilterProviderStack'
import {IndexAndSearchContent} from '../components/IndexAndSearchContent'

export function Index() {
  const payload = useRoutePayload<IndexPayload>()
  const showDeprecationNotice = isFeatureEnabled('copilot_extensions_deprecation_notice')

  return (
    <SearchAndFilterProviderStack>
      <MarketplaceHeader />
      <div data-hpc>
        <PageLayout>
          {showDeprecationNotice && (
            <PageLayout.Header>
              <Banner
                aria-label="Warning"
                title="Warning"
                variant="warning"
                description={
                  <>
                    We are deprecating GitHub Copilot Extensions on November 10, 2025, in favor of the Model Context
                    Protocol (MCP). You can read more about this change in our{' '}
                    <Link
                      href="https://github.blog/changelog/2025-09-24-deprecate-github-copilot-extensions-github-apps/"
                      target="_blank"
                      inline
                    >
                      changelog post
                    </Link>
                    .
                  </>
                }
              />
            </PageLayout.Header>
          )}
          <PageLayout.Pane position="start">
            <MarketplaceNavigation categories={payload.categories} />
          </PageLayout.Pane>
          <PageLayout.Content as="div">
            <IndexAndSearchContent payload={payload} />
          </PageLayout.Content>
        </PageLayout>
      </div>
    </SearchAndFilterProviderStack>
  )
}

try{ Index.displayName ||= 'Index' } catch {}